module.exports = __webpack_public_path__ + "static/media/KP.2a076390.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KP.svg
// module id = 291
// module chunks = 0